import React, {Component, useState} from 'react';
import FaqBanner from './FaqBanner';
import FaqAccordion from "./FaqAccordion";

class FaqPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<main>
				<FaqBanner />
				<div className="main-body mt-50 mb-50">
					<div className="container">
						<div className="row">
							<div className="offset-lg-1 col-lg-10 col-md-12 post-list">

								<FaqAccordion />

							</div>
						</div>
					</div>
				</div>
			</main>
		);
	}
}

export default FaqPage;
